<template>
	<div class="grid-flex-container pa-4">
		<div style="flex-grow: 1">
			<v-form ref="form">
				<v-card class="pa-4">
					<v-card-title
						><span class="text-h5"
							>Source Project</span
						></v-card-title
					>
					<v-row>
						<v-col
							><v-select
								:disabled="adminEnvironment"
								v-model="selectedSourceClient"
								:items="clients"
								item-text="Name"
								item-value="Id"
								name="Source Client"
								label="Source Client"
								required
							>
							</v-select
						></v-col>
						<v-col
							><v-select
								v-model="selectedSourceProject"
								:items="projects"
								item-text="Name"
								item-value="Id"
								name="Source Project"
								label="Source Project"
								required
							>
							</v-select
						></v-col>
					</v-row>
				</v-card>

				<v-card class="pa-4">
					<v-card-title
						><span class="text-h5"
							>Destination Project</span
						></v-card-title
					>

					<v-row>
						<v-col>
							<v-select
								v-model="selectedDestinationClient"
								:items="clients"
								item-text="Name"
								item-value="Id"
								:rules="destinationClientRules"
								name="Client"
								label="Client"
								required
							>
							</v-select>
							<v-text-field
								v-model="formProject.Name"
								name="Name"
								label="Name"
								:rules="nameRules"
								required
							/>
							<v-text-field
								v-if="formProject.Id"
								v-model="formProject.Id"
								name="Id"
								label="Project ID"
								disabled
							/>
							<v-text-field
								v-model="formProject.Description"
								name="Description"
								label="Description"
								required
							/>
						</v-col>
						<v-col>
							<v-text-field
								v-model="formDbConnection.SqlServerName"
								name="sqlservername"
								label="SQL Server Name"
								:rules="sqlServerNameRules"
								required
							/>

							<v-text-field
								v-model="formDbConnection.DatabaseName"
								name="databasename"
								label="Database Name"
								:rules="databaseNameRules"
								required
							/>
							<v-select
								v-model="loginMethod"
								:items="loginItems"
								item-text="text"
								item-value="id"
								name="LoginMethod"
								:rules="loginMethodRules"
								label="LoginMethod"
								required
							/>
						</v-col>
						<v-col>
							<v-text-field
								v-if="loginMethod == loginItems[0].id"
								v-model="formDbConnection.SqlUserName"
								name="SqlUserName"
								label="SQL UserName"
								required
							/>
							<v-text-field
								v-if="loginMethod == loginItems[0].id"
								v-model="formDbConnection.SqlPassword"
								:append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
								:type="show ? 'text' : 'password'"
								@click:append="togglePassVisibility"
								name="sqlPassword"
								label="SQL Password"
								required
							/>
						</v-col>
					</v-row>
				</v-card>
				<v-card class="pa-4"
					><span class="text-h5">Clone Options</span>
					<v-row>
						<v-col>
							<v-autocomplete
								:items="sourceCloneOptions.Entities"
								v-model="selectedEntities"
								item-text="Name"
								return-object
								label="Database Tables"
								:multiple="true"
								chips
								deletable-chips
							>
							</v-autocomplete>

							<v-autocomplete
								:items="sourceCloneOptions.Grids"
								v-model="selectedDatasets"
								item-text="Name"
								return-object
								label="Datasets"
								:multiple="true"
								chips
								deletable-chips
							>
							</v-autocomplete>
							<v-autocomplete
								:items="sourceCloneOptions.InventoryForms"
								v-model="selectedForms"
								item-text="Name"
								return-object
								label="Inventory Forms"
								:multiple="true"
								chips
								deletable-chips
							>
							</v-autocomplete>
							<v-autocomplete
								:items="sourceCloneOptions.Activities"
								v-model="selectedActivities"
								item-text="Name"
								return-object
								label="Activities"
								:multiple="true"
								chips
								deletable-chips
							>
							</v-autocomplete>
							<v-autocomplete
								:items="sourceCloneOptions.Reports"
								v-model="selectedReports"
								item-text="Name"
								return-object
								label="Reports"
								:multiple="true"
								chips
								deletable-chips
							>
							</v-autocomplete>
							<v-autocomplete
								:items="sourceCloneOptions.CloneData"
								v-model="selectedCloneData"
								item-text="Name"
								return-object
								label="Clone data"
								:multiple="true"
								chips
								deletable-chips
							>
							</v-autocomplete>
						</v-col>
					</v-row>
				</v-card>
			</v-form>
			<v-spacer />
		</div>
		<v-card-actions>
			<v-spacer />
			<v-btn color="primary" @click="onSubmit"> Clone </v-btn>
		</v-card-actions>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	ProjectCloneGetters,
	AuthGetterTypes,
	ClientContextGetters,
} from '../../../store/getters';
import {
	ProjectCloneActions,
	ClientContextActions,
} from '../../../store/actions';
import { SqlLoginMethod } from '../../../enums/sqlLoginMethod';

export default {
	name: 'ProjectClone',
	data() {
		return {
			method: '',
			id: '',
			show: false,
			selectedEntities: [],
			selectedDatasets: [],
			selectedDestinationClient: null,
			showDialog: false,
			cloneData: false,
			selectedForms: [],
			selectedActivities: [],
			selectedReports: [],
			selectedCloneData: [],
			selectedSourceClient: null,
			selectedSourceProject: null,
			formProject: {},
			formDbConnection: {},
			loginItems: [
				{ id: SqlLoginMethod.SqlLogin, text: 'SQL Login' },
				{
					id: SqlLoginMethod.WindowsAuthentication,
					text: 'Windows Authentication',
				},
			],
			destinationClientRules: [
				(v) => !!v || 'Destination client must be selected',
			],
			sqlServerNameRules: [(v) => !!v || 'Sql Server Name is required'],
			nameRules: [(v) => !!v || 'Name is required'],
			databaseNameRules: [
				(v) => !!v || 'Database Name is required',
				(value) => {
					const pattern = /^[A-Za-z_][A-Za-z0-9_][^\s]*$/;
					return (
						pattern.test(value) || 'Invalid database name format'
					);
				},
			],

			loginMethodRules: [(v) => !!v || 'Login Method must be selected'],
			loginMethod: null,
		};
	},
	watch: {
		selectedEntities() {
			this.sourceCloneOptions.Grids.forEach((x) => {
				x.disabled = !this.validateDatasets(x);
				if (x.disabled == true) {
					let index = this.selectedDatasets.findIndex(
						(y) => y.EntityId == x.EntityId
					);
					if (index > -1) this.selectedDatasets.splice(index, 1);
				}
			});
		},
		selectedDatasets() {
			this.sourceCloneOptions.InventoryForms.forEach((x) => {
				x.disabled = !this.validateByEntity(x);
				if (x.disabled == true) {
					let index = this.selectedForms.findIndex(
						(y) => y.GridViewId == x.GridViewId
					);
					if (index > -1) this.selectedForms.splice(index, 1);
				}
			});
			this.sourceCloneOptions.Activities.forEach((x) => {
				x.disabled = !this.validateByEntity(x);
				if (x.disabled == true) {
					let index = this.selectedActivities.findIndex(
						(y) => y.Id == x.Id
					);
					if (index > -1) this.selectedActivities.splice(index, 1);
				}
			});
			this.sourceCloneOptions.Reports.forEach((x) => {
				x.disabled = !this.validateByEntity(x);
				if (x.disabled == true) {
					let index = this.selectedReports.findIndex(
						(y) => y.Id == x.Id
					);
					if (index > -1) this.selectedReports.splice(index, 1);
				}
			});
			this.sourceCloneOptions.CloneData.forEach((x) => {
				x.disabled = !this.validateByEntity(x);
				if (x.disabled == true) {
					let index = this.selectedCloneData.findIndex(
						(y) => y.Name == x.Name
					);
					if (index > -1) this.selectedCloneData.splice(index, 1);
				}
			});
		},
		loginMethod() {
			this.formDbConnection.SqlUserName = '';
			this.formDbConnection.SqlPassword = '';
		},
		selectedSourceClient() {
			if (this.selectedSourceClient)
				this.$store
					.dispatch(
						ProjectCloneActions.GET_PROJECTS,
						this.selectedSourceClient
					)
					.then(() => (this.selectedSourceProject = null));
		},

		selectedSourceProject() {
			if (this.selectedSourceProject)
				this.$store
					.dispatch(
						ProjectCloneActions.GET_CLONE_OPTIONS,
						this.sourceProject
					)
					.then(() => {
						this.selectedDatasets = [];
						this.selectedEntities = [];
						this.selectedActivities = [];
						this.selectedForms = [];
						this.selectedReports = [];
						this.selectedCloneData = [];

						this.sourceCloneOptions.Grids.forEach((x) => {
							x.disabled = !this.validateDatasets(x);
						});
						this.sourceCloneOptions.InventoryForms.forEach((x) => {
							x.disabled = !this.validateByEntity(x);
						});
						this.sourceCloneOptions.Activities.forEach((x) => {
							x.disabled = !this.validateByEntity(x);
						});
						this.sourceCloneOptions.Reports.forEach((x) => {
							x.disabled = !this.validateByEntity(x);
						});
						this.sourceCloneOptions.CloneData.forEach((x) => {
							x.disabled = !this.validateByEntity(x);
						});
					});
		},
	},
	computed: {
		...mapGetters({
			projects: [ProjectCloneGetters.PROJECTS],
			clients: [ProjectCloneGetters.CLIENTS],
			sourceCloneOptions: [ProjectCloneGetters.CLONE_OPTIONS],
			isAdmin: [AuthGetterTypes.IS_SUPERADMIN],
			selectedClient: [ClientContextGetters.SELECTED_CLIENT],
		}),
		adminEnvironment() {
			if (this.isAdmin) return false;
			else {
				return true;
			}
		},
		sourceProject() {
			return {
				ProjectId: this.selectedSourceProject,
				ClientId: this.selectedSourceClient,
			};
		},
		destinationProject() {
			return {
				ClientId: this.selectedDestinationClient,
				ProjectName: this.formProject.Name,
				ProjectDescription: this.formProject.Description,
				SqlServerName: this.formDbConnection.SqlServerName,
				DatabaseName: this.formDbConnection.DatabaseName,
				SqlUserName: this.formDbConnection.SqlUserName,
				SqlPassword: this.formDbConnection.SqlPassword,
				LoginMethod: this.loginMethod,
			};
		},
		destinationCloneOptions() {
			return {
				Entities: this.selectedEntities,
				Grids: this.selectedDatasets,
				Activities: this.selectedActivities,
				Reports: this.selectedReports,
				InventoryForms: this.selectedForms,
				CloneData: this.selectedCloneData,
			};
		},
	},

	mounted() {
		this.$store.dispatch(ProjectCloneActions.GET_CLIENTS).then(() => {
			if (!this.isAdmin) {
				this.selectedSourceClient = this.selectedClient.Id;
			}
		});
	},
	methods: {
		validateDatasets(item) {
			var result = true;
			var isSelectedMain = this.selectedEntities.find(
				(y) => y.Id == item.EntityId
			);
			if (!isSelectedMain) result = false;

			item.Fields.forEach((x) => {
				if (x.LinkEntityName != null) {
					var entity = this.selectedEntities.find(
						(y) => y.Name == x.LinkEntityName
					);
					if (!entity) result = false;
				}
			});
			return result;
		},
		validateByEntity(item) {
			var result = false;
			if (this.selectedDatasets) {
				this.selectedDatasets.forEach((x) => {
					var entity = this.sourceCloneOptions.Grids.find(
						(y) => y.Id == x.Id
					);
					if (entity && entity.EntityId == item.EntityId) {
						result = true;
					}
				});
			}
			return result;
		},

		onSubmit() {
			let payload = {
				SourceProject: this.sourceProject,
				DestinationProject: this.destinationProject,
				CloneOptions: this.destinationCloneOptions,
			};
			if (this.$refs.form.validate()) {
				this.$store
					.dispatch(ProjectCloneActions.CLONE_PROJECT, payload)
					.then((success) => {
						if (success) {
							this.$refs.form.reset();
							this.sourceCloneOptions = [];
							this.$store.dispatch(
								ClientContextActions.RELOAD_CLIENT_CONTEXT
							);
							alert('Success!');
						}
					});
			}
		},
		togglePassVisibility() {
			this.show = !this.show;
		},
	},
};
</script>
<style>
.theme--light.v-list-item--disabled .v-icon {
	color: rgba(0, 0, 0, 0.3);
}
</style>
